import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import style from './style';
import ContextModelHeader from './Header';
import { FormProvider, useForm } from 'react-hook-form';
import Informations from './Informations';
import Attributs from './Attributs';
/*
import Email from './Email';
*/
import AssociatedContext from './AssociatedContext';
import FicheContext from 'components/context/FicheContext';
import FicheContextMenu from 'components/context/FicheContext/Menu';
import FicheContextContent from 'components/context/FicheContext/Content';
import SaveButton from 'components/context/FicheContext/SaveButton';
import i18next from 'i18next';
import { updateContextModel } from 'services/edge/ContexteService';
import { ERROR } from 'services/common/Constants';
import { Context } from 'states/Store';
import { Trans } from 'react-i18next';
import { useAlert } from '../../../../components/common/hooks/useAlert';

const navigationItems = [
  {
    id: 'informations',
    icon: 'context/navigation/information',
    label: 'context.ficheContext.navigation.informations',
  },
  {
    id: 'attributs',
    icon: 'context/navigation/attributs',
    label: 'context.ficheContext.navigation.attributs',
  },
/*  {
    id: 'mail',
    icon: 'context/navigation/mail',
    label: 'context.ficheContext.navigation.mail',
  },*/
  {
    id: 'context',
    icon: 'context/navigation/business',
    label: 'context.ficheContext.navigation.context',
  },
];

const ContextModel = ({
  context,
  contextList,
  handleClose,
  onValidateSuccess,
  readOnly = false
}) => {
  const { classes } = style();
  const [state, dispatch] = useContext(Context);
  const navigationRef = useRef();
  const [currentContext, setCurrentContext] = useState(context);
  const [
    ,
    setAttributesWithCalculationReferences,
  ] = useState();
  const formMethods = useForm({
    mode: 'onChange',
    delayError: 500,
    defaultValues: {
      id: currentContext.id,
      name: currentContext.name,
      description: currentContext.description,
      corpsEmail: currentContext.corpsEmail,
      code: currentContext.code,
      expirationDate: currentContext.expirationDate,
      contextAttributes: currentContext.contextAttributes,
      tiersAttributes: currentContext.tiersAttributes,
      demandeAttributes: currentContext.demandeAttributes,
    },
  });
  const {onSuccess} = useAlert();
  const { getValues, reset, trigger } = formMethods;

  useEffect(() => {
    reset({
      id: currentContext.id,
      name: currentContext.name,
      description: currentContext.description,
      corpsEmail: currentContext.corpsEmail,
      code: currentContext.code,
      expirationDate: currentContext.expirationDate,
      contextAttributes: currentContext.contextAttributes,
      tiersAttributes: currentContext.tiersAttributes,
      demandeAttributes: currentContext.demandeAttributes,
    });
    const attributesWithCalculationReferences = [
      ...currentContext.contextAttributes,
      ...currentContext.tiersAttributes,
      ...currentContext.demandeAttributes,
    ]
      .filter((att) => att.referencingCalculations)
      .map((att) => att.id);
    setAttributesWithCalculationReferences(attributesWithCalculationReferences);
  }, [currentContext, reset]);

  /*  const findDeletedAttributesWithCalculationReferences = (formValues,attributesWithCalculationReferences) => {
      const attributesToSave = [
        ...formValues.contextAttributes,
        ...formValues.tiersAttributes,
        ...formValues.demandeAttributes
      ].map((att) => att.id);
      return attributesWithCalculationReferences.filter(att => !attributesToSave.includes(att));
    }*/

  const scrollToFirstError = () => {
    const errorElement = document.querySelector(
      '[aria-invalid="true"], .Mui-error'
    );
    if (errorElement && errorElement.scrollIntoView) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      errorElement.focus?.();
    }
  };

  const saveModel = useCallback(async () => {
    const isValid = await trigger();
    if (!isValid) {
      scrollToFirstError();
      return;
    }

    const formValues = getValues();
    const name = formValues.name;

    try {
      await updateContextModel(state.account.id, context.id, formValues);
      onSuccess(<Trans i18nKey="demandes.contextModel.notifications.edited"><b>{{name}}</b></Trans>)
      onValidateSuccess();
    } catch (e) {
      dispatch({
        type: 'ALERT',
        alert: { type: ERROR, msg: 'INTERNAL_ERROR' },
      });
    }
  }, [
    dispatch,
    getValues,
    onValidateSuccess,
    state.account.id,
    trigger,
    onSuccess,
    context
  ]);

  return (
    <FicheContext handleClose={handleClose} isOpen={!!context}>
      <ContextModelHeader
        back={handleClose}
        context={currentContext}
        contextList={contextList}
        setCurrentContext={setCurrentContext}
        readOnly={readOnly}
      />
      <FicheContextContent ref={navigationRef}>
        <FicheContextMenu
          navigationItems={navigationItems}
          ref={navigationRef}
        />
        <div className={classes.separator}></div>
        <FormProvider {...formMethods}>
          <form>
            <Informations context={currentContext} readOnly={readOnly}/>
            <Attributs context={currentContext} readOnly={readOnly} />
{/*
            <Email context={currentContext} />
*/}
            <AssociatedContext context={currentContext} readOnly={readOnly}/>
          </form>
        </FormProvider>
        {!readOnly &&
          <SaveButton onClick={saveModel}>
            {i18next.t('demandes.contextModel.ficheModel.save')}
          </SaveButton>
        }
      </FicheContextContent>
    </FicheContext>
  );
};

export default ContextModel;
